//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'flow'
let resource_name = 'flujo'
let resource_name_plural = 'flujos'

let state = {
  blocks: [],
  lastFlowsUpdate: null,
  updatingFlows: false,
  updatingBlocks: false,
  recent_flows: []
}

state[resource + 's'] = []

//functions receive state
let getters = {
  loadingFlow (state) {
    return state.updatingFlows || state.updatingBlocks
  },
  recentFlows (state) {
    return state.recent_flows
  }
}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      commit('toggleUpdatingBlocks', true)
      commit('setBlocks', [])
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})

      if (res.data.success && res.data.resource && res.data.resource.Blocks) commit('setBlocks', res.data.resource.Blocks)

      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }

      commit('toggleUpdatingBlocks')
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success) {
        commit('pushFlow', res.data.resource)

        if (params.callback)
          params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success) {
        commit('updateFlow', res.data.resource)

        if (params.callback)
          params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success) {
        commit('removeFlow', params.flow_id)

        if (params.callback)
          params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  async setPlatform ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/setPlatform`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error en plataforma del ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error en plataforma del ${resource_name}.`})
      console.error(e)
    }
  },
  async clone ({ commit }, params) {
    try {
        //account_id en el body
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/cloneV2`, params)
      if(res.data.success && params.callback) {
        commit('pushFlow', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error clonando el ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error clonando el ${resource_name}.`})
      console.error(e)
    }
  },
  async move ({ commit }, { params = {}, callback = () => {} }) {
    try {
      const res = await Vue.request.patch(
        `${resource}/${params[resource + '_id']}/move`,
        params
      )
      const { data } = res
      const { resource: dataResource } = data

      if (!data.success) throw new Error(`Ocurrió un error enviando el ${resource_name}.`)

      commit('updateFlow', dataResource)

      return callback(data)
    } catch (e) {
      console.error(e)

      const data = { error: e.message }

      return callback(data)
    }
  },
  async translate ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/translate`, {data: params})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error traduciendo el ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error traduciendo el ${resource_name}.`})
      console.error(e)
    }
  },
  async allQueue ({ commit, state }, params) {
    try {
      // avoid to refresh too often
      if (state.updatingFlows || !canUpdateFlows(state.lastFlowsUpdate)) {
        if(params.callback)
          params.callback({ success: true })

        return
      } else {
        commit('setLastFlowsUpdate')
      }

      commit('toggleUpdatingFlows', true)
      let res = await Vue.request.get(`account/${params.account_id}/${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }

      commit('toggleUpdatingFlows')
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)

      commit('toggleUpdatingFlows')
    }
  },
  async showMany ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/showMany`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async addList ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/list`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error agregando lista a ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agregando lista a ${resource_name}.`})
      console.error(e)
    }
  },
  async getLists ({ commit }, { params = {}, callback = () => {} }) {
    try {
      const res = await Vue.request.get(
        `${resource}/${params[resource + '_id']}/lists`,
        { params }
      )

      const { data } = res

      if (!data.success) throw new Error(`Ocurrió un error eliminando lista de ${resource_name}.`)

      return callback(data)
    } catch (e) {
      console.error(e)

      const data = { error: e.message }

      return callback(data)
    }
  },
  async removeList ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}/list`, {data: params})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando lista a ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando lista de ${resource_name}.`})
      console.error(e)
    }
  },
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  pushFlow (state, flow) {
    if (flow && flow.flow_id) {
      const index = state.flows.findIndex(({ name }) => {
        const flowName = flow.name
          .replace(/\(copy\)/i, '')
          .replace(/\s*\(copy\)/gi, ' (copy)')
          .trim()

        return name === flowName
      })

      if (index > -1) return state.flows.splice(index + 1, 0, flow)

      state.flows.splice(0, 0, flow)
    }
  },
  updateFlow (state, flow) {
    if (flow && flow.flow_id) {
      let index = state.flows.findIndex(f => f.flow_id == flow.flow_id)
      if (index >= 0) {
        state.flows.splice(index, 1, flow)
      }
    }
  },
  removeFlow (state, flow_id) {
    let index = state.flows.findIndex(f => f.flow_id == flow_id)
    if (index >= 0) {
      state.flows.splice(index, 1)
    }
  },
  setBlocks (state, items) {
    if (Array.isArray(items)){
      state.blocks = items
    } else {
      state.blocks = []
    }
  },
  toggleUpdatingFlows (state, updating) {
    state.updatingFlows = Boolean(updating)
  },
  toggleUpdatingBlocks (state, updating) {
    state.updatingBlocks = Boolean(updating)
  },
  setLastFlowsUpdate (state) {
    state.lastFlowsUpdate = Vue.prototype.$moment()
  },
  setRecentFlows (state, flow) {
    let index = state.recent_flows.findIndex(f => f.flow_id == flow.flow_id)
    if (index >= 0) {
      state.recent_flows.splice(index, 1)
    }
    state.recent_flows.push(flow)
  },
  removeRecentFlows  (state, flow) {
    let index = state.recent_flows.findIndex(f => f.flow_id == flow.flow_id)
    if (index >= 0) {
      state.recent_flows.splice(index, 1)
    }
  },
}

var canUpdateFlows = function (lastFlowsUpdate) {
  if (lastFlowsUpdate) {
    let ellapsedMinutes = Vue.prototype.$moment().diff(lastFlowsUpdate, 'minutes')
    return ellapsedMinutes >= 1
  }

  return true
}

export default {
  state,
  mutations,
  actions,
  getters
}
